import Constants from '@/Constants';
import React, { useEffect, useState } from 'react';
import './style.scss';

interface TimerUI {
    hours: number;
    minutes: number;
    seconds: number;
}

interface Props {
    minutes: number;
    onEnded: CallableFunction;
}

const addZero = (value: number): string => {
    return value < 10 ? `0${value}` : `${value}`;
};

/**
 * Runs a timer and displays it.
 * @param minutes The number of minutes the timer will start from.
 * @param onEnded A callback function to be called when the timer ends. The elapsed time in seconds will be passed as parameter.
 */
const Timer: React.FC<Props> = (props: Props, {}) => {
    const { minutes, onEnded } = props;
    const [unit, setUnit] = useState<'min' | 'h'>('h');

    const totalInSeconds = minutes * 60;
    let timeoutId: NodeJS.Timer;
    let elapsedSeconds = 0;

    const calculateTimeLeft = (): TimerUI => {
        let timeLeft: any = {};
        const difference = totalInSeconds - elapsedSeconds;

        if (difference > 0) {
            timeLeft = {
                hours: Math.floor((difference / (60 * 60)) % 24),
                minutes: Math.floor((difference / 60) % 60),
                seconds: Math.floor(difference % 60),
            };
        } else {
            timeLeft = { hours: 0, minutes: 0, seconds: 0 };
            clearInterval(timeoutId);
            onEnded(elapsedSeconds);
        }

        return timeLeft;
    };

    const [timeLeft, setTimeLeft] = useState<TimerUI>(calculateTimeLeft());

    useEffect(() => {
        timeoutId = setInterval(() => {
            ++elapsedSeconds;
            setTimeLeft(calculateTimeLeft());
        }, 1000);
        return () => clearInterval(timeoutId);
    }, [minutes]);

    useEffect(() => {
        if (timeLeft.hours === 0) {
            setUnit('min');
        }
    }, [timeLeft.hours]);

    return (
        <div className="timer-container">
            <div className="timer-icon">
                <span className="material-icons-outlined align-middle">{Constants.icons.ALARM}</span>
            </div>
            <div className="timer-value">
                {addZero(timeLeft.hours)}:{addZero(timeLeft.minutes)}:<span className="timer-seconds">{addZero(timeLeft.seconds)}</span> {unit}
            </div>
        </div>
    );
};

export default Timer;
